import React from 'react';

import Check from './Check';
import './Checkbox.scss';

interface IProps {
  size?: number;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: 'primary' | 'secondary';
  disabled?: boolean;
  title?: string;
}

export default function Checkbox({size = 20, checked, onChange, type = 'secondary', disabled, title = ''}: IProps) {
  const getCheckboxTypeClassName = () => {
    switch (type) {
      case 'primary':
        return 'checkbox--primary';
      case 'secondary':
        return 'checkbox--secondary';
      default:
        return '';
    }
  };

  return (
    <div className={`checkbox ${getCheckboxTypeClassName()}`}>
      <input
        type="checkbox"
        title={title}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="checkbox__input"
      />
      <span
        style={{width: size, height: size}}
        className={`checkbox__checkmark ${checked ? 'checkbox__checkmark--checked' : ''}`}
      >
        {checked && <Check className="checkbox__check" />}
      </span>
    </div>
  );
}
